import { render, staticRenderFns } from "./last-win.vue?vue&type=template&id=2ae6536c&scoped=true&"
import script from "./last-win.vue?vue&type=script&lang=js&"
export * from "./last-win.vue?vue&type=script&lang=js&"
import style0 from "./last-win.vue?vue&type=style&index=0&id=2ae6536c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6536c",
  null
  
)

export default component.exports